import { render, staticRenderFns } from "./KakaoIcon.vue?vue&type=template&id=05247ccb&scoped=true&"
import script from "./KakaoIcon.vue?vue&type=script&lang=js&"
export * from "./KakaoIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05247ccb",
  null
  
)

export default component.exports